import { ReactNode, useState } from "react";
import { Box, styled } from "@mui/material";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileMenu } from "./MobileMenu";

const LayoutContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  background: "var(--background-white)",
});

const MainContent = styled(Box)(() => ({
  marginTop: 0,
  flex: 1,
  width: "100%",
}));

interface LayoutProps {
  children: ReactNode;
  headerTransparent?: boolean;
  dataTheme?: string;
}

export const Layout = ({ children, headerTransparent = true, dataTheme }: LayoutProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <LayoutContainer data-theme={dataTheme}>
      <Header onMenuClick={handleMenuOpen} transparent={headerTransparent} />
      <MainContent>{children}</MainContent>
      <Footer />
      <MobileMenu open={mobileMenuOpen} onClose={handleMenuClose} />
    </LayoutContainer>
  );
};
